<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1">
				<!--搜索-->
				<div class="search_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<van-search v-model="searchVal" show-action placeholder="Key Words" @search="onSearch">
						<template #action>
						    <div @click="onSearch">
								Search
								<!-- <van-icon size="22px" color="#0B318F" name="search" /> -->
							</div>
						</template>
					</van-search>
				</div>
				<!--搜索-->
				<div class="title"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>Total: {{ total }} results</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div v-if="listData.length > 0" class="list_box">
					<van-list
					  v-model="searchLoading"
					  :finished="isLoadAll"
					  finished-text="Data loading completed"
					  :immediate-check="false"
					  @load="onLoad"
					>
						<div
							v-for="(value, index) in listData"
							:key="index"
							class="list_el"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							@click="goInfo(value)"
						>
							<div class="tips">{{ value.leixing }}</div>
							<div class="tit">{{ value.title }}</div>
							<div v-if="value.content" class="txt">{{ value.content }}</div>
						</div>
					</van-list>
				</div>
				<div v-else>
					<van-empty image="search" description="Sorry, but nothing matched your search terms." />
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import { searchList } from '@/api/public';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			searchVal: '',
			listData: [],
			total: 0,
			noPage: 1,
			searchLoading: false,
			isLoadAll: false,
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//document.title = 'Search - CorDx';
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goInfo(value) {
			let that = this;
			let pathUrl = '';
			let unionid = '';
			switch (value.leixing){
				case 'Products': // flu-a%2Fb-&-covid-19-multiplex-rapid-test cordx-tyfast-flu-a/b-&-covid-19-multiplex-rapid-test
					if(value.custom == 'flu-a/b-&-covid-19-multiplex-rapid-test') {
						that.$router.push({ name: 'Productsinfos', params: { productInfoIds: value.custom, } });
					}else if(value.custom == 'cordx-tyfast-flu-a-b-covid-19-at-home-rapid-multiplex-test-cordx'){
						that.$router.push({ name: 'Productsinfos2', params: { productInfoIds: value.custom, } });
					}else if(value.custom == 'cordx-tyfast-covid-19-ag-rapid-test'){
						that.$router.push({ name: 'Productsinfos3', params: { productInfoIds: value.custom, } });
					}else if(value.custom == 'cordx-tyfast-multi-drug-rapid-test-cup') {
						that.$router.push({ name: 'Productsinfos4', params: { productInfoIds: value.custom, } });
					}else if(value.custom == 'cordx-tyfast-rsv-rapid-test') {
						that.$router.push({ name: 'cordx-tyfast-rsv-rapid-test' });
					}else if(value.custom == 'cordx-tyfast-ovulation-test-pregnancy-test-combo') {
						that.$router.push({ name: 'cordx-tyfast-ovulation-test-pregnancy-test-combo' });
					}else if(value.custom == 'cordx-one-step-hcg-pregnancy-test-cassette') {
						that.$router.push({ name: 'cordx-one-step-hcg-pregnancy-test-cassette' });
					}else if(value.custom == 'cordx-tyfast-cotinine-cot-rapid-test') {
						that.$router.push({ name: 'cordx-tyfast-cotinine-cot-rapid-test' });
					}else if(value.custom == 'cordx-tyfast-fsh-rapid-test') {
						that.$router.push({ name: 'cordx-tyfast-fsh-rapid-test' });
					}else {
						that.$router.push({ name: 'Productsinfo', params: { productInfoId: value.custom, } });
					}
					break;
				case 'Events':
					that.$router.push({ name: 'Eventsinfo', params: { eventsInfoId: value.custom, } });
					break;
				default:
					that.$router.push({ name: 'Resourcesinfo', params: { resourcesInfoId: value.custom, } });
					break;
			}
		},
		//请求搜索列表
		getSearchList() {
			let that = this;
			that.searchLoading = true;
			if(that.searchVal) {
				searchList({
					keyword: that.searchVal,
					page: that.noPage,
					page_size: 10,
					language: sessionStorage.getItem('lang'),
				}).then(res => {
					that.listData = [...that.listData, ...res.data.data]
					that.total = res.data.total;
					that.searchLoading = false;
					if(res.data.data.length < 10) {
						that.isLoadAll = true;
					}
				});
			}else {
				that.$toast('Please enter the information you want to search for');
			}
		},
		//搜索
		onSearch() {
			let that = this;
			that.noPage = 1;
			that.listData = [];
			that.isLoadAll = false;
			that.getSearchList();
			window.scroll(0, 0);
		},
		//翻页
		onLoad() {
			let that = this;
			that.noPage = that.noPage + 1;
			that.getSearchList();
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	.block_2{
		padding: 24px 20px 0 20px;
		.list_box{
			.list_el{
				display: inline-block;
				width: 100%;
				margin-bottom: 36px;
				//margin: 21px 20px 0 20px;
				cursor: pointer;
				.txt{
					font-size: 18px;
					color: #706B69;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.tit{
					margin: 20px 0 10px 0;
					font-size: 21px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.tips{
					display: inline-block;
					padding: 8px 21px 5px 21px;
					border-radius: 21px;
					background-color: #EFEFEF;
					color: #0B318F;
					font-size: 18px;
				}
			}
		}
	}
	.block_1{
		.title{
			padding: 8px 20px 0 20px;
			text-align: right;
		}
		.search_box{
			padding: 8px 0;
		}
	}
}
</style>
<style scoped>
>>> .block_2 .van-empty__description{
	text-align: center;
}
</style>
